// select the correct language here
// import language from "./../../src/common/i18n/en_uk.json";
// import language from "./../../src/common/i18n/de_de.json";
// import language from "./../../src/common/i18n/et_EE.json";
// import language from "./../../src/common/i18n/fr_FR.json";
// import language from "./../../src/common/i18n/fr_BE.json";
// import language from "./../../src/common/i18n/nl_NL.json";
import language from "./../../src/common/i18n/nl_BE.json";

const dictionary = language; //eslint-disable-line
// if needed change some strings here or add some
dictionary.notifications_title = "oops";
dictionary.Promospot = "Bijlagen";
dictionary.accountLoggedWithInfo = "U bent momenteel ingelogd met";
dictionary.region = "Editie";
dictionary.ChooseRegion = "Kies je editie";
dictionary.disclaimer = "Gebruikersvoorwaarden";
dictionary.platformversion = "Platformversie";
export default dictionary;



// WEBPACK FOOTER //
// ./clients/mhu-nb/dictionary.js